export default __webpack_public_path__ + "images/file_c18050defd34892ec1d779f22e30b041.svg";